// Libs
import _size from 'lodash/size'
import emptyObject from './emptyObject'

export default (object) => _size(object) ? object : emptyObject
